module.exports = __webpack_public_path__ + "img/8.4c3b5745.png";